import styled from "@emotion/styled";
import { Box, Button, Label } from "Components";
import { theme } from "Application";
import { PageRoot } from "Styles/PageStyles";

export const ModalOverlay = styled(Box)`
    position: fixed;
    background: #00000030;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
`;

export const RotaPageRoot = styled(PageRoot)`
    padding-bottom: 6rem;
`;

export const BannerContainer = styled.div`
    background: ${theme.palette.quarternary.light};
    padding: 12px 18px;
    text-align: center;
    cursor: pointer;
`;

export const PageWrapper = styled(Box)`
    padding: 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    @media only screen and (max-width: 1024px) {
        padding: 30px 20px;
    }
`;

export const DateNavRow = styled(Box)`
    display: flex;
    flex-wrap: wrap;
    gap: 15px 30px;
    align-items: center;
`;

export const Separator = styled.div`
    width: 100%;
    border-top: 1px dashed ${theme.palette.tableHeader.main};
    margin: 30px 0px;
`;

export const PageHeaderLabel = styled(Label)`
    padding: 0px 30px 0px;
    @media only screen and (max-width: 1024px) {
        padding: 0 20px;
        z-index: 1;
    }
`;

export const ClickableBannerLabel = styled(Label)`
    cursor: pointer;
    text-decoration: underline;
`;

export const RotaNavButton = styled(Button)`
    height: 40px;
    min-width: 130px;
`;

export const AddRotaButton = styled(Button)`
    height: 40px;
    min-width: 220px;
`;
